// extracted by mini-css-extract-plugin
export default {"form":"SessionActionsList_form__HTlg7"};